{
  "version": 1,
  "asset_id": "67c3d82c-33b1-4fea-90d7-80721591e581",
  "project_id": "bc28ec3a-38d3-4a78-848c-5618f322d6de",
  "url": "/__l5e/assets-v1/67c3d82c-33b1-4fea-90d7-80721591e581/timothy-ng-96.webp",
  "r2_key": "a/v1/bc28ec3a-38d3-4a78-848c-5618f322d6de/67c3d82c-33b1-4fea-90d7-80721591e581/timothy-ng-96.webp",
  "original_filename": "timothy-ng-96.webp",
  "size": 2264,
  "content_type": "image/webp",
  "created_at": "2026-07-29T18:51:27Z"
}
